import { render, staticRenderFns } from "./publishProducts.vue?vue&type=template&id=3a92bf3b&scoped=true"
import script from "./publishProducts.vue?vue&type=script&lang=js"
export * from "./publishProducts.vue?vue&type=script&lang=js"
import style0 from "./publishProducts.vue?vue&type=style&index=0&id=3a92bf3b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a92bf3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a92bf3b')) {
      api.createRecord('3a92bf3b', component.options)
    } else {
      api.reload('3a92bf3b', component.options)
    }
    module.hot.accept("./publishProducts.vue?vue&type=template&id=3a92bf3b&scoped=true", function () {
      api.rerender('3a92bf3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/cooperation/publishProducts.vue"
export default component.exports